/**
 * Import global listeners used in the application here as a side effect of importing this file.
 * This ensures that the modules are not tree-shaken away during the build process
 * even when no other typeScript file import them.
 */
import {registerCopyLinkListener} from "@/shared/entityLinks";
import {addCopyButton, initSingleDateRangePickers} from "@/shared/utils/input";

if (document.readyState !== 'loading') {
	registerCopyLinkListener();
} else {
	document.addEventListener('DOMContentLoaded', registerCopyLinkListener);
}

$(function () {
	addCopyButton($("[data-copy='button']"));
	$("[data-toggle='tooltip']").tooltip();
	if ($.fn.daterangepicker && typeof globals !== "undefined") {
		const dateRangePickers = $(".daterange-single");
		initSingleDateRangePickers(dateRangePickers);
	}

	// Navigate to hash if hash targets a tab
	const hash = window.location.hash;
	if (hash) {
		$('ul.nav a[href="' + hash + '"]').tab("show");
	}
});
